import axios from "axios";
import { Form } from "devextreme-react";
import { Label, SimpleItem } from "devextreme-react/form";

import React, { useRef, useState, useEffect } from "react";

export default function MoreInformation(props) {
  const { type, SEQ } = props;
  const [data, setData] = useState(null);
  const formRef = useRef(null);

  // const items = ["cpu", "memory", "stgeCap"];

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt/${type}/${SEQ}?moreInfo=true`
      )
      .then((result) => {
        setData(result.data);
      });
  }, []);

  const buttonOptions = {
    text: "SAVE",
    stylingMode: "text",
    type: "default",
    onClick: (e) => {
      axios
        .put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/eqptMgmt/${type}/${SEQ}`,
          formRef.current.instance.option("formData")
        )
        .then(() => {});
    },
  };

  const renderFormItem = (item) => {
    return <span>{item.editorOptions.value}</span>;
  };

  return (
    <React.Fragment>
      <Form
        id="form-eqptMgmt-moreInfo"
        ref={formRef}
        formData={data}
        labelMode={"outside"}
        showColonAfterLabel={false}
        labelLocation={"top"}
        minColWidth={300}
        validationGroup="eqptMgmt-moreInfo"
        colCount={2}
        colCountByScreen={{
          sm: 2,
          md: 4,
        }}
        screenByWidth={(width) => {
          return width < 720 ? "sm" : "md";
        }}
      >
        {type == "1" && (
          <SimpleItem
            dataField="cpu"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
            }}
          >
            <Label text="CPU" />
          </SimpleItem>
        )}
        {type == "1" && (
          <SimpleItem
            dataField="memory"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
            }}
          >
            <Label text="Memory" />
          </SimpleItem>
        )}
        {type == "1" && (
          <SimpleItem
            dataField="stgeCap"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
            }}
          >
            <Label text="Storage Capacity" />
          </SimpleItem>
        )}
        {type == "2" && (
          <SimpleItem
            dataField="inch"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
            }}
          >
            <Label text="Inch" />
          </SimpleItem>
        )}
        {/* <ButtonItem
          horizontalAlignment="right"
          verticalAlignment="bottom"
          buttonOptions={buttonOptions}
        /> */}
      </Form>
    </React.Fragment>
  );
}
